import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotReadygki7zhqkkp9u as InternalReactiveNotReady,
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance,
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
} from './ReactiveState.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { BaseReactive302n39o7i5yop as BaseReactive } from './abstracts.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Dispatchers_getInstanceitgtkvqfcnx3 as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { Rememberkif8023snbmn as Remember } from './Remember.mjs';
import {
  lens2x0usmj7eco4 as lens,
  lens2po2j99uxhjgr as lens_0,
  set1ugseoes1jrmg as set,
  ReactiveWithMutableValue1h1r6ig7acce5 as ReactiveWithMutableValue,
} from './coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function updateOnce($this) {
  var currentRememberedState = $this.rak_1.sah();
  var tmp;
  if (!$this.qak_1) {
    var tmp_0;
    if (!$this.pak_1) {
      tmp_0 = true;
    } else {
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
      var tmp_1 = _ReactiveState___get_raw__impl__92ipya(currentRememberedState);
      tmp_0 = !(tmp_1 instanceof InternalReactiveNotReady());
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.rah(currentRememberedState);
  }
}
function startListening($this) {
  var tmp = $this;
  tmp.sak_1 = $this.rak_1.vah(() => {
    var tmp;
    if (!$this.qak_1) {
      $this.rah($this.rak_1.sah());
      tmp = Unit_instance;
    }
    return Unit_instance;
  });
  updateOnce($this);
}
function stopListening($this) {
  var tmp0_safe_receiver = $this.sak_1;
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  $this.sak_1 = null;
}
var MutableRememberClass;
function MutableRemember() {
  if (MutableRememberClass === VOID) {
    class $ extends BaseReactive() {
      static tak(stopListeningWhenOverridden, useLastWhileLoading, coroutineContext, deactivationDelay, initialValue) {
        stopListeningWhenOverridden = stopListeningWhenOverridden === VOID ? true : stopListeningWhenOverridden;
        useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
        coroutineContext = coroutineContext === VOID ? Dispatchers_getInstance().yac_1 : coroutineContext;
        deactivationDelay = deactivationDelay === VOID ? null : deactivationDelay;
        var $this = this.ial();
        $this.oak_1 = stopListeningWhenOverridden;
        $this.pak_1 = useLastWhileLoading;
        $this.qak_1 = false;
        $this.rak_1 = Remember().jal(coroutineContext, $this.pak_1, deactivationDelay, initialValue);
        $this.sak_1 = null;
        return $this;
      }
      rah(value) {
        super.rah(value);
      }
      sah() {
        if (!this.qak_1 && this.sak_1 == null) {
          updateOnce(this);
        }
        return super.sah();
      }
      kal() {
        if (!this.qak_1 && this.sak_1 == null) {
          startListening(this);
        }
      }
      lal() {
        if (this.sak_1 == null)
          return Unit_instance;
        stopListening(this);
        if (!this.qak_1 && !this.pak_1) {
          this.rah(Companion_getInstance().oah_1);
        }
      }
      eak(value) {
        if (!this.qak_1) {
          this.qak_1 = true;
          if (this.oak_1) {
            stopListening(this);
          }
        }
        this.rah(_ReactiveState___init__impl__fvdp9b(value));
      }
      d52() {
        if (this.qak_1) {
          this.qak_1 = false;
          if (this.oak_1) {
            startListening(this);
          }
          var currentSharedState = this.rak_1.sah();
          var tmp;
          if (!this.pak_1) {
            tmp = true;
          } else {
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
            var tmp_0 = _ReactiveState___get_raw__impl__92ipya(currentSharedState);
            tmp = !(tmp_0 instanceof InternalReactiveNotReady());
          }
          if (tmp) {
            this.rah(currentSharedState);
          }
        }
      }
    }
    protoOf($).vak = lens;
    protoOf($).dak = lens_0;
    protoOf($).iah = set;
    initMetadataForClass($, 'MutableRemember', VOID, VOID, [ReactiveWithMutableValue(), BaseReactive()], [1]);
    MutableRememberClass = $;
  }
  return MutableRememberClass;
}
function mutableRemember(useLastWhileLoading, coroutineContext, initialValue) {
  useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
  coroutineContext = coroutineContext === VOID ? Dispatchers_getInstance().yac_1 : coroutineContext;
  return MutableRemember().tak(true, useLastWhileLoading, coroutineContext, null, initialValue);
}
//region block: exports
export {
  MutableRemember as MutableRememberyv35kz5kmml7,
  mutableRemember as mutableRemember1h6fyyolumj0o,
};
//endregion

//# sourceMappingURL=MutableRemember.mjs.map
